import React, { Component } from "react";

export default class Content extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div>
            <div className="headTitle">{this.props.data.name}</div>
    
            <div className="preamble">

                <div className="title">{this.props.data.preamble.title}</div>
                <div className="time">{this.props.data.time}</div>

            </div>

            <div className="content">
                {this.props.data.preamble.wordlist.map((word, i) => <div key={i}>{word}</div>)}
            </div>

            {this.props.data.mainWords.map((word, i) => <div key={i}>
                <div className="title">{word.title}</div>
                <div className="content">{word.wordlist.map((wd, j) => <div>{wd}</div>)}</div>
            </div>)}

            <div className="signature">{this.props.data.company}</div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/component/Content.js